import { Button, Link, TextField } from "@mui/material";
import { SnackbarComponent } from "components";
import LayoutOnboardingComponent from "components/layout-onboarding/LayoutOnboardingComponent";
import { emptyToastMessage } from "consts/common";
import { forgotPassword } from "features/forgot-password/service/ForgotPasswordService";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import storage from "services/storage";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();

  const [message, setMessage] = useState(emptyToastMessage);
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [subtitle, setSubtitle] = useState(
    "Enter your email address and we will send new password to you",
  );
  const [title1, setTitle1] = useState("Forgot");

  useEffect(() => {
    if (storage.getToken()) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  const onSubmit = async (event) => {
    event.preventDefault();

    setSubmitted(true);

    if (!email) {
      setMessage({
        title: "Failed",
        desc: "Email cannot be blank",
        type: "error",
      });

      return;
    }

    const payload = { email };
    const response = await forgotPassword(payload);

    const { info } = response || {};

    if (info && info.title === "Forgot Password Successful") {
      setSubmitSuccess(true);

      setTitle1("Email");
      setSubtitle("Please check your email to get new password");
    } else {
      const { title, description } = info;

      setMessage({
        title,
        desc: description,
        type: "error",
      });
    }
  };

  const onEmailChange = (e) => setEmail(e.target.value);

  const navigateLogin = () => navigate("/");

  const onCloseSnackbar = () => {
    setMessage(emptyToastMessage);
  };

  return (
    <LayoutOnboardingComponent subtitle={subtitle} title={title1}>
      {submitSuccess || (
        <form className='grid gap-[24px]' onSubmit={onSubmit}>
          <div className='form-input'>
            <p className='form-input-label'>Email</p>

            <TextField
              error={submitted && !email}
              name='email'
              placeholder='Input Email'
              value={email}
              onChange={onEmailChange}
            />
          </div>

          <Button
            fullWidth
            type='submit'
            variant='contained'
            onClick={onSubmit}
          >
            Send to Email
          </Button>

          <Link
            className='text-center'
            href=''
            underline='none'
            onClick={navigateLogin}
          >
            <span className='text-green'>Back to Login</span>
          </Link>
        </form>
      )}

      {submitSuccess && (
        <Button variant='contained' onClick={navigateLogin}>
          Login
        </Button>
      )}

      {message.title && (
        <SnackbarComponent
          labelTitle={message.title}
          labelMessage={message.desc}
          type={message.type}
          onClose={onCloseSnackbar}
        />
      )}
    </LayoutOnboardingComponent>
  );
};

export default ForgotPasswordPage;
